import React, { useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Area,
  AreaChart,
} from "recharts";
import { Select } from "antd";
import "./MemberChart.css";

const { Option } = Select;

function MemberChart({ data }) {
  const [year, setYear] = useState("This Year");

  // Dummy data if no data provided
  const defaultData = [
    { month: "Jan", members: 250 },
    { month: "Feb", members: 500 },
    { month: "Mar", members: 750 },
    { month: "Apr", members: 450 },
    { month: "May", members: 850 },
    { month: "Jun", members: 700 },
    { month: "Jul", members: 1000 },
    { month: "Aug", members: 850 },
    { month: "Sep", members: 900 },
    { month: "Oct", members: 750 },
    { month: "Nov", members: 850 },
    { month: "Dec", members: 1250 },
  ];

  const chartData = data && data.length > 0 ? data : defaultData;

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="chart-tooltip">
          <p className="tooltip-label">{label}</p>
          <p className="tooltip-value">
            <span className="tooltip-dot"></span>
            Members: <strong>{payload[0].value}</strong>
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="member-chart-card">
      <div className="chart-header">
        <h3 className="chart-title">Member Registrations Overview</h3>
        <Select
          value={year}
          onChange={setYear}
          className="chart-year-select"
          size="small"
        >
          <Option value="This Year">This Year</Option>
          <Option value="Last Year">Last Year</Option>
          <Option value="This Month">This Month</Option>
        </Select>
      </div>

      <ResponsiveContainer width="100%" height={280}>
        <AreaChart data={chartData} margin={{ top: 20, right: 20, left: 0, bottom: 5 }}>
          <defs>
            <linearGradient id="colorMembers" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#ff0055" stopOpacity={0.35} />
              <stop offset="100%" stopColor="#ff0055" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" vertical={false} />
          <XAxis
            dataKey="month"
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#888", fontSize: 12 }}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            tick={{ fill: "#888", fontSize: 12 }}
            tickFormatter={(value) => (value >= 1000 ? `${value / 1000}K` : value)}
          />
          <Tooltip content={<CustomTooltip />} />
          <Area
            type="monotone"
            dataKey="members"
            stroke="#ff0055"
            strokeWidth={3}
            fill="url(#colorMembers)"
            dot={{ fill: "#ff0055", r: 4, strokeWidth: 2, stroke: "#fff" }}
            activeDot={{ r: 6, strokeWidth: 3, stroke: "#fff", fill: "#ff0055" }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}

export default MemberChart;